/**
 * User footer for authenticated app pages.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../../providers';
import Logo from '../common/Logo';
import { ROUTES } from '../../utils/constants';
import '../../styles/public-layout.css';

const UserFooter = () => {
  const navigate = useNavigate();
  const { language } = useI18n();
  const currentYear = new Date().getFullYear();

  const productLinks = [
    { label: language === 'fr' ? 'Comment ça marche' : 'How It Works', path: ROUTES.HOW_IT_WORKS },
    { label: language === 'fr' ? 'Tarifs' : 'Pricing', path: ROUTES.PRICING },
    { label: language === 'fr' ? 'À propos' : 'About', path: ROUTES.ABOUT },
  ];

  const supportLinks = [
    { label: language === 'fr' ? "Centre d'aide" : 'Help Center', path: ROUTES.HELP },
    { label: language === 'fr' ? 'Contact' : 'Contact', path: ROUTES.CONTACT },
    { label: language === 'fr' ? 'Statut' : 'Status', path: ROUTES.SYSTEM_STATUS },
  ];

  const legalLinks = [
    { label: language === 'fr' ? "Conditions d'utilisation" : 'Terms of Service', path: ROUTES.TERMS },
    { label: language === 'fr' ? 'Politique de confidentialité' : 'Privacy Policy', path: ROUTES.PRIVACY_POLICY },
  ];

  const pills = [
    language === 'fr' ? 'MTN Mobile Money' : 'MTN Mobile Money',
    language === 'fr' ? 'Orange Money' : 'Orange Money',
    'XAF',
    language === 'fr' ? 'Cameroun' : 'Cameroon',
  ];

  return (
    <footer className="footer-sleek">
      <div className="footer-sleek-bg" aria-hidden="true" />
      <div className="footer-sleek-inner">
        {/* CTA strip */}
        <div className="footer-sleek-cta-strip">
          <p className="footer-sleek-cta-text">
            {language === 'fr' ? 'Prêt à ' : 'Ready to '}
            <span>{language === 'fr' ? 'protéger vos transactions' : 'protect your transactions'}</span>
            {' ?'}
          </p>
          <div className="footer-sleek-cta-actions">
            <button type="button" onClick={() => navigate(ROUTES.CREATE_TRANSACTION)} className="footer-sleek-cta-btn">
              {language === 'fr' ? 'Créer une transaction' : 'Create Transaction'}
            </button>
            <span className="footer-sleek-trust-badge">
              <span className="footer-sleek-trust-badge-dot" aria-hidden />
              {language === 'fr' ? '98% taux de réussite' : '98% success rate'}
            </span>
          </div>
        </div>

        {/* Main grid */}
        <div className="footer-sleek-grid">
          <div className="footer-sleek-brand">
            <div className="footer-sleek-logo-wrap">
              <Logo size="footer" />
            </div>
            <p className="footer-sleek-tagline">
              {language === 'fr' ? (
                <>
                  Plateforme d'escrow sécurisée pour le Cameroun. <strong>Protégez</strong> vos transactions avec confiance.
                </>
              ) : (
                <>
                  Secure escrow platform for Cameroon. <strong>Protect</strong> your transactions with confidence.
                </>
              )}
            </p>
          </div>

          <div className="footer-sleek-column">
            <h4>{language === 'fr' ? 'Produit' : 'Product'}</h4>
            <ul className="footer-sleek-links">
              {productLinks.map((link) => (
                <li key={link.path}>
                  <button type="button" onClick={() => navigate(link.path)} className="footer-sleek-link">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-sleek-column">
            <h4>{language === 'fr' ? 'Support' : 'Support'}</h4>
            <ul className="footer-sleek-links">
              {supportLinks.map((link) => (
                <li key={link.path}>
                  <button type="button" onClick={() => navigate(link.path)} className="footer-sleek-link">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-sleek-column">
            <h4>{language === 'fr' ? 'Légal' : 'Legal'}</h4>
            <ul className="footer-sleek-links">
              {legalLinks.map((link) => (
                <li key={link.path}>
                  <button type="button" onClick={() => navigate(link.path)} className="footer-sleek-link">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Payment / region pills */}
        <div className="footer-sleek-pills">
          {pills.map((label) => (
            <span key={label} className="footer-sleek-pill">
              {label}
            </span>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="footer-sleek-bottom">
          <div className="footer-sleek-meta">
            <span className="footer-sleek-status">
              <span className="footer-sleek-status-dot" aria-hidden />
              {language === 'fr' ? 'En ligne' : 'Online'}
            </span>
            <span className="footer-sleek-version">v1.0.0</span>
            <span className="footer-sleek-region">{language === 'fr' ? 'Cameroun' : 'Cameroon'}</span>
          </div>
          <p className="footer-sleek-copy">
            © {currentYear} WekaTrust. {language === 'fr' ? 'Tous droits réservés.' : 'All rights reserved.'}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default UserFooter;
